/**
 * Transport configuration for the Sayagie API.
 *
 * Deliberately independent of `utils/configs.js` and of the `/apps/init`
 * bootstrap that feeds `API_URL()` in `utils/common-utils.js`. The legacy
 * stack resolves its base URL at runtime from the old backend; this layer
 * must not, so the two can run side by side until parity is proven.
 *
 * Verified against dev on 2026-09-07 (see HexagieApp
 * docs/web-auth-flow-implementation.md §1).
 */

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://dev-api.sayaty.com";

/**
 * Required on every request, public or private. Missing it returns 401.
 *
 * Open decision (D2): this ships visible in the bundle. If it has to stay
 * secret the app must call through a server-side proxy that injects it,
 * which changes API_BASE_URL above.
 */
export const API_KEY = process.env.REACT_APP_API_KEY || "99999";

export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL || "wss://dev-api.sayaty.com/connect-ws";
